import apiConfig from "@/config/apiConfig";
import axios from "axios";
import { ls } from "@/utils/util"
const rootPath = apiConfig.companyApi; //不带manage


//用手机号获取JWT
export const jwtToken = {
  phoneGetJwt: rootPath + "/web/common/jwtToken/phoneGetJwt", // 获取JWT(get)
  JwtCheck: rootPath + "/web/common/jwtToken/JwtCheck", // 校验JWT(get)
  jwtQuit: rootPath + "/web/common/jwtToken/jwtQuit", // 清除JWT(get)
}


//政策申报主体表
export const policySubject = {
  pageList: rootPath + "/webPolicy/policySubject/pageList", // 分页数据(get)
  detail: rootPath + "/webPolicy/policySubject/detail", // 批量删除(del)
}



//申报材料表
export const policyData = {
  pageList: rootPath + "/webPolicy/policyData/pageList", // 分页数据(get)
  policyListData: rootPath + "/webPolicy/policyData/policyListData", // 无分页数据(get)
  detail: rootPath + "/webPolicy/policyData/detail", // 批量删除(del)
}

// 用户信息获取
export const policyCompany = {
  addPolicyCompany: rootPath + "/webPolicy/policyCompany/addPolicyCompany", // 新增编辑(get)
  doPhone: rootPath + "/webPolicy/policyCompany/doPhone", // 新增编辑(get)
  pageList: rootPath + "/webPolicy/policyCompany/pageList", // 分页数据(get)
  detail: rootPath + "/webPolicy/policyCompany/detail", // 详情(get)
}

//政策申报流程
export const processPolicy = {
  selectProcessList: rootPath + "/webVerifyPolicy/processPolicy/selectProcessList", // 分页数据(get)
}

// 用户申报
export const policyCompanyData = {
  submitCompanyData: rootPath + "/webVerifyPolicy/policyCompanyData/submitCompanyData", // 提交(get)
  addPCData: rootPath + "/webVerifyPolicy/policyCompanyData/addPCData", // 新增(post)
  updatePCData: rootPath + "/webVerifyPolicy/policyCompanyData/updatePCData", // 新增(post)
  pageList: rootPath + "/webVerifyPolicy/policyCompanyData/pageList", // 分页数据(get)
  selectByPage: rootPath + "/webVerifyPolicy/policyCompanyData/selectByPage", // 新分页数据(get)
  detail: rootPath + "/webVerifyPolicy/policyCompanyData/detail", // 详情(get)
  deleteById: rootPath + "/webVerifyPolicy/policyCompanyData/deleteById", // 删除(get)
}

// 项目申报GWT验证接口
export const VerifyPolicy = {
  getVerifyPolicy: (method,url,params) => {
  let getAxiosData = null
  axios({
      method: method,
      headers: {
        AuthenticationPhone: ls.get('jwtphone'),
        AuthenticationJwt: ls.get('jwtMain')
      },
      url: url,
      params:params
  }).then(res => {
    if(res){
      getAxiosData = res.data.data.records
    }
  })
  setTimeout(() => {
    console.log(getAxiosData,'出来')
    return getAxiosData
  }, 3000);
}
}
